module.exports = __webpack_public_path__ + "img/room.76a00bf4.svg";